/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_List_LabelInputs */

const en_us2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise list`)
};

const pt_br2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de exercícios`)
};

const es_419_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de ejercicios`)
};

const pt_pt2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de exercícios`)
};

const fr_fr2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des exercices`)
};

const de_de2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungsliste`)
};

const it_it2_exercise_list_label = /** @type {(inputs: Exercise_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco esercizi`)
};

/**
* | output |
* | --- |
* | "Exercise list" |
*
* @param {Exercise_List_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_list_label = /** @type {((inputs?: Exercise_List_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_List_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_list_label(inputs)
	if (locale === "es-419") return es_419_exercise_list_label(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_list_label(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_list_label(inputs)
	if (locale === "de-DE") return de_de2_exercise_list_label(inputs)
	if (locale === "it-IT") return it_it2_exercise_list_label(inputs)
	return en_us2_exercise_list_label(inputs)
});
export { exercise_list_label as "exercise.list_label" }